import React from 'react';
import { makeStyles } from '@mui/styles';
import Paper from '@mui/material/Paper';
import { Grid } from '@mui/material';
import PersonIcon from '@mui/icons-material/Person';

const useStyles = makeStyles({
    table: {
        minWidth: 340,
    },
    root: {
    },
    tableCell: {
        paddingRight: 4,
        paddingLeft: 5
    },
    // Mobile card styles
    mobileContainer: {
        display: 'none',
        '@media (max-width: 768px)': {
            display: 'block',
        },
    },
    desktopContainer: {
        display: 'block',
        '@media (max-width: 768px)': {
            display: 'none',
        },
    },
    mobileCard: {
        background: '#fff',
        borderRadius: '12px',
        padding: '16px',
        marginBottom: '12px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
        border: '1px solid #f0f0f0',
        boxSizing: 'border-box',
    },
    cardHeader: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        marginBottom: '12px',
    },
    userInfo: {
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
        flex: 1,
    },
    userIcon: {
        width: '40px',
        height: '40px',
        borderRadius: '50%',
        backgroundColor: 'rgba(111, 41, 129, 0.1)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: '#6f2981',
        flexShrink: 0,
    },
    userName: {
        fontSize: '15px',
        fontWeight: 600,
        color: '#333',
        margin: 0,
        wordBreak: 'break-word',
    },
    srNo: {
        fontSize: '12px',
        color: '#999',
        backgroundColor: '#f5f5f5',
        padding: '4px 10px',
        borderRadius: '12px',
        fontWeight: 500,
        flexShrink: 0,
    },
    cardBody: {
        display: 'flex',
        flexDirection: 'column',
        gap: '10px',
        paddingTop: '12px',
        borderTop: '1px solid #f0f0f0',
    },
    infoRow: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
    },
    infoLabel: {
        fontSize: '12px',
        color: '#888',
        fontWeight: 500,
    },
    infoValue: {
        fontSize: '13px',
        color: '#333',
        fontWeight: 500,
        textAlign: 'right',
        wordBreak: 'break-word',
        maxWidth: '60%',
    },
    assessmentName: {
        fontSize: '14px',
        color: '#6f2981',
        fontWeight: 600,
        marginTop: '4px',
    },
});
export default function CustomizedTables(props) {
    const classes = useStyles();
    const {tableData} = props;

    const hasData = tableData && tableData.length > 0;

    return (
        <Grid item xs={12}>
            <Paper className={classes.root}>
                {hasData ? (
                <>
                {/* Mobile Card Layout */}
                <div className={classes.mobileContainer}>
                    {tableData.map((item, index) => (
                        <div key={`mobile-${index}`} className={classes.mobileCard}>
                            <div className={classes.cardHeader}>
                                <div className={classes.userInfo}>
                                    <div className={classes.userIcon}>
                                        <PersonIcon fontSize="small" />
                                    </div>
                                    <div>
                                        <p className={classes.userName}>{item['username']}</p>
                                        <p className={classes.assessmentName}>{item['assessment_name']}</p>
                                    </div>
                                </div>
                                <span className={classes.srNo}>#{index + 1}</span>
                            </div>
                            <div className={classes.cardBody}>
                                <div className={classes.infoRow}>
                                    <span className={classes.infoLabel}>UserExam ID</span>
                                    <span className={classes.infoValue}>{item['userexam_id']}</span>
                                </div>
                                <div className={classes.infoRow}>
                                    <span className={classes.infoLabel}>Group Name</span>
                                    <span className={classes.infoValue}>{item['group_name']}</span>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>

                {/* Desktop Table Layout */}
                <div className={`listing_div ${classes.desktopContainer}`}>
                    <div className="list_head">
                        <p>
                            <span className="admin-srno" >Sr.No</span>
                            <span className="admin-name" >Username</span>
                            <span className="admin-browser" >Userexam Id</span>
                            <span className="admin-browser" >Group Name</span>
                            <span className="admin-device" >Assessment Name</span>
                        </p>
                    </div>
                    {tableData.map((item,index) => {
                        return (
                        <div key={`desktop-${index}`} className={index % 2 !== 0 ? "list_even list_name" : "list_odd list_name"}  >
                        <div className="list_detail_2">
                        <span className="admin-srno">{index + 1}</span>
                        <span  className="admin-name">{item['username']}</span>
                        <span  className="admin-browser">{item['userexam_id']}</span>
                        <span  className="admin-browser">{item['group_name']}</span>
                        <span  className="admin-device">{item['assessment_name']}</span>
                        </div>
                        </div>
                        );
                    })}
                </div>
                </>
                ) : (
                <div style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: "48px 24px",
                  textAlign: "center"
                }}>
                  <div style={{
                    width: "64px",
                    height: "64px",
                    borderRadius: "50%",
                    backgroundColor: "#f5f0f7",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    marginBottom: "16px"
                  }}>
                    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#7030a0" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                      <polyline points="14 2 14 8 20 8"></polyline>
                      <line x1="16" y1="13" x2="8" y2="13"></line>
                      <line x1="16" y1="17" x2="8" y2="17"></line>
                      <polyline points="10 9 9 9 8 9"></polyline>
                    </svg>
                  </div>
                  <h4 style={{
                    margin: "0 0 8px 0",
                    fontSize: "18px",
                    fontWeight: "600",
                    color: "#333"
                  }}>
                    No Records Found
                  </h4>
                  <p style={{
                    margin: "0",
                    fontSize: "14px",
                    color: "#666",
                    maxWidth: "300px"
                  }}>
                    No pending results to regenerate.
                  </p>
                </div>
                )}
            </Paper>
        </Grid>
    );
}